import { z } from "zod";

export const DashboardOverviewResponseSchema = z.object({
  oeeAverage24h: z.number().min(0).max(100).nullable(),

  producedToday: z.number().int().nonnegative(),

  oldestAlarmAt: z.string().datetime({ offset: true }).nullable(),

  activeAlarmsCount: z.number().int().nonnegative(),

  // Débito de justificativa visível em altitude gerencial.
  pendingJustificationsCount: z.number().int().nonnegative(),
});

export type DashboardOverviewResponse = z.infer<typeof DashboardOverviewResponseSchema>;
